import React, { useState, memo } from "react"
import { LazyLoadImage } from "react-lazy-load-image-component"
import s from "./PureImage.less"

interface iProps {
  src?: string
  onLoad?: (event: React.SyntheticEvent<HTMLImageElement, Event>) => void
  onError?: (event: React.SyntheticEvent<HTMLImageElement, Event>) => void
  brokenImage?: string
  missingImage?: string
  visibleByDefault?: boolean
  className?: string
}

const PureImage: React.FC<iProps> = ({
  src,
  onLoad,
  onError,
  className,
  brokenImage,
  missingImage,
}) => {
  const [isError, setError] = useState(false)

  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    setError(true)
    onError && onError(e)
  }

  const getSrc = () => (src ? (isError ? brokenImage : src) : missingImage)
  const getClass = () =>
    `${!src ? `${s.missingImage} ` : ""}${
      isError ? `${s.brokenImage} "` : ""
    }${className}`

  return (
    <LazyLoadImage
      onLoad={onLoad}
      onError={handleError}
      src={getSrc()}
      className={getClass()}
      threshold={20}
      loading={"lazy"}
      placeholder={<div className={s.isLoading}></div>}
      height={200}
    />
  )
}

PureImage.defaultProps = {
  brokenImage: "/img/broken_picture.svg",
  missingImage: "/img/missing_picture.svg",
  visibleByDefault: false,
}

export default memo(
  PureImage,
  (prev: iProps, next: iProps) => prev.src === next.src,
)
